module.exports = __webpack_public_path__ + "img/add-photo.de94b77b.svg";